export class Vat {
  constructor(
    public defaultVat?: number,
  ) { }

  clone() {
    return new Vat(
      this.defaultVat
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/vat.ts